import { markSessionExpired } from '../model/session-profile-storage'
import { redirectToProbeStackLogin } from './session-navigation'

let redirectStarted = false

/** Use the same expired-session transition for /me and ForgeSphere service 401s. */
export function expireSessionAndRedirectToLogin(): void {
  if (typeof window === 'undefined' || redirectStarted) return
  redirectStarted = true
  try {
    markSessionExpired()
  } finally {
    redirectToProbeStackLogin()
  }
}

export function isSessionInvalidated(): boolean {
  return redirectStarted
}

export function resetSessionInvalidation(): void {
  redirectStarted = false
}
